import type { ChatbotConfig } from "./types";

export const chatbotConfig: ChatbotConfig = {
  enableChatbot: true,
  enableTelemetry: false,
  allowFreeText: true,
  allowGuidedFlow: true,
  allowHistory: true,
  allowExtractiveQa: true,
  maxRecommendations: 2,
  maxExpandedRecommendations: 4,
  maxSnippets: 5,
  minResponseDelayMs: 650,
  maxResponseDelayMs: 1200
};
